import React from 'react';
import { navigate, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandFonts,
  fontWeights,
  fontSize,
  standardTransition,
} from '../styles';
import { Link } from './ui';
import { buildUrl } from '../utils';

const StyledProjectCard = styled.article`
  position: relative;
  cursor: pointer;
`;

// moved up for hover
const StyledHeading = styled.h3`
  position: relative;
  padding-bottom: 10px;
  color: ${standardColours.white};
  font-family: ${brandFonts.secondary};
  font-weight: ${fontWeights.semibold};
  ${fontSize(19)};
  text-align: center;

  ${minBreakpointQuery.tsmall`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(25)};
  `}

  &:before,
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 2px;
    width: 50%;
    background-color: ${standardColours.white};
    ${standardTransition('transform')};
  }

  &:before {
    left: 0;
    transform: translateX(50%);
  }

  &:after {
    right: 0;
    transform: translateX(-50%);
  }
`;

const StyledContent = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${standardColours.black};
    opacity: 0.4;
    ${standardTransition('opacity')};
  }

  &:hover {
    &:before {
      opacity: 0.2;
    }

    ${StyledHeading} {
      &:before,
      &:after {
        transform: translateX(0);
      }
    }
  }
`;

const ProjectCard = ({ data: { title, slug, featuredImage } }) => {
  const urlPath = `plants-for-business/${slug}`;

  return (
    <StyledProjectCard
      onClick={() => {
        navigate(buildUrl(urlPath));
      }}
    >
      <GatsbyImage
        image={featuredImage.gatsbyImageData}
        alt={featuredImage.alt}
      />
      <StyledContent>
        <StyledHeading>
          <Link to={urlPath}>{title}</Link>
        </StyledHeading>
      </StyledContent>
    </StyledProjectCard>
  );
};

export default ProjectCard;

export const ProjectCardFragment = graphql`
  fragment ProjectCardFragment on DatoCmsProject {
    id
    title
    slug
    featuredImage {
      gatsbyImageData(width: 400, height: 500)
      alt
    }
  }
`;
